import { baseUrl } from "./utils";

export const get_vendor_detail = async (id, setLoading) => {
  try {
    setLoading(true);
    const body = new FormData();
    body.append("userid", 1);
    body.append("ingress", 1);
    body.append("id", id);
    const response = await fetch(baseUrl + "vendordetails", {
      method: "POST",
      body: body,
    });
    const res = await response.json();
    setLoading(false);
    return res;
  } catch (error) {
    console.log(error);
    setLoading(false);
  }
};

export const get_driver_detail = async (id, setLoading) => {
  try {
    setLoading(true);
    const body = new FormData();
    body.append("userid", 1);
    body.append("ingress", 1);
    body.append("id", typeof id === 'object' ? id?.id : id); 
    const response = await fetch(baseUrl + "driverdetails", {
      method: "POST",
      body: body,
    });
    const res = await response.json();
    setLoading(false);
    return res;
  } catch (error) {
    console.log(error);
    setLoading(false);
  }
};
export const get_godown_detail = async (id, setLoading) => {
  try {
    setLoading(true);
    const body = new FormData();
    body.append("userid", 1);
    body.append("ingress", 1);
    body.append("id", id);
    const response = await fetch(baseUrl + "godowndetails", {
      method: "POST",
      body: body,
    });
    const res = await response.json();
    setLoading(false);
    return res;
  } catch (error) {
    console.log(error);
    setLoading(false);
  }
};
export const get_vehicle_detail = async (id, setLoading) => {
  try {
    setLoading(true);
    const body = new FormData();
    body.append("userid", 1);
    body.append("ingress", 1);
  body.append("id", typeof id === 'object' ? id?.id : id); 
    const response = await fetch(baseUrl + "vehicledetails", {
      method: "POST",
      body: body,
    });
    const res = await response.json();
    setLoading(false);
    return res;
  } catch (error) {
    console.log(error);
    setLoading(false);
  }
};
export const get_customer_detail = async (id, setLoading) => {
  try {
    setLoading(true);
    const body = new FormData();
    body.append("userid", 1);
    body.append("ingress", 1);
    body.append("id", id);
    const response = await fetch(baseUrl + "customer-details", {
      method: "POST",
      body: body,
    });
    const res = await response.json();
    setLoading(false);
    return res;
  } catch (error) {
    console.log(error);
    setLoading(false);
  }
};
export const get_dp_detail = async (id, setLoading) => {
  try {
    setLoading(true);
    const body = new FormData();
    body.append("userid", 1);
    body.append("ingress", 1);
    body.append("id", typeof id === 'object' ? id?.id : id); 

    const response = await fetch(baseUrl + "dpdetails", {
      method: "POST",
      body: body,
    });
    const res = await response.json();
    setLoading(false);
    return res;
  } catch (error) {
    console.log(error);
    setLoading(false);
  }
};
export const get_order_detail = async (id, orderid, type, setLoading) => {
  try {
    setLoading && setLoading(true);
    const body = new FormData();
    body.append("action", "order_by_id");
    body.append("orderid", orderid);
    body.append("id", id); 
    if (type) {
      body.append("type", type); // ✅ Added type input
    }

    const response = await fetch(baseUrl + "orders.php", {
      method: "POST",
      body: body,
    });

    const res = await response.json();
    setLoading && setLoading(false);
    return res;
  } catch (error) {
    console.error("API error:", error);
    setLoading && setLoading(false);
    throw error;
  }
};

export const get_dc_pdf = async ({ userid, orderid, details_id, dc_no }) => {
  try {
    const queryParams = new URLSearchParams({
      userid,
      orderid,
      details_id,
      dc_no
    }).toString();

    const url = `https://gaswale.vensframe.com/api/admin/dc_pdf.php?${queryParams}`;

    const response = await fetch(url, {
      method: "GET"
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // If API returns PDF directly
    const blob = await response.blob();
    return blob;

    // If API returns JSON, use:
    // const data = await response.json();
    // return data;

  } catch (error) {
    console.error("Error fetching DC PDF:", error);
    throw error;
  }
};

export const get_receipt_detail = async (id, setLoading) => {
  try {
    setLoading(true);
    const body = new FormData();
    body.append("userid", 1);
    body.append("ingress", 1);
    const response = await fetch(baseUrl + "receipt.php", {
      method: "POST",
      body: body,
    });
    const res = await response.json();
    setLoading(false);
    return res;
  } catch (error) {
    console.log(error);
    setLoading(false);
  }
};
// import { baseUrl } from "./utils";

// export const get_vendor_detail = async (id, setLoading) => {
//   try {
//     setLoading(true);
//     const body = new FormData();
//     body.append("userid", 1);
//     body.append("ingress", 1);
//     body.append("id", id);
//     const response = await fetch(baseUrl + "vendordetails", {
//       method: "POST",
//       body: body,
//     });
//     const res = await response.json();
//     console.log("policy-list", res);
//     setLoading(false);
//     return res;
//   } catch (error) {
//     console.log(error);
//     setLoading(false);
//   }
// };

// export const get_driver_detail = async (id, setLoading) => {
//   try {
//     setLoading(true);
//     const body = new FormData();
//     body.append("userid", 1);
//     body.append("ingress", 1);
//     body.append("id", id);
//     const response = await fetch(baseUrl + "driverdetails", {
//       method: "POST",
//       body: body,
//     });
//     const res = await response.json();
//     console.log("policy-list", res);
//     setLoading(false);
//     return res;
//   } catch (error) {
//     console.log(error);
//     setLoading(false);
//   }
// };
// export const get_dp_detail = async (id, setLoading) => {
//   try {
//     setLoading(true);
//     const body = new FormData();
//     body.append("userid", 1);
//     body.append("ingress", 1);
//     body.append("id", id);
//     const response = await fetch(baseUrl + "dpdetails", {
//       method: "POST",
//       body: body,
//     });
//     const res = await response.json();
//     console.log("policy-list", res);
//     setLoading(false);
//     return res;
//   } catch (error) {
//     console.log(error);
//     setLoading(false);
//   }
// };
